import {put, takeEvery, call} from 'redux-saga/effects';
import Api, {ApiMethods} from 'feedback-system/middleware/api';
import {
    STATISTIC_FETCH_REQUEST,
    STATISTIC_FETCH_SUCCESS,
    STATISTIC_FETCH_ERROR
} from '../constans';

import {Profile} from 'feedback-system/dto/IProfile';
import {Feedback} from 'feedback-system/dto/IFeedback';

export interface Action {
    type: typeof STATISTIC_FETCH_REQUEST;
    periodId: number;
    user: Profile | null;
}

function* statisticFetch(action: Action) {
    try {
        const {user} = action;
        let endpoint = `feedback/statistic/${action.periodId}`;
        if (user) {
            endpoint = `feedback/overview/${user.id}/${action.periodId}`;
        }
        const feedback = (yield call(Api.fetch, {
            endpoint,
            method: ApiMethods.GET
        })).responseData;

        const profiles = (yield call(Api.fetch, {
            endpoint: 'profiles/get',
            method: ApiMethods.POST,
            body: feedback.reduce((iDs: number[], fb: Feedback) => ([...iDs, fb.authorId, fb.recipientId]), [])
        })).responseData;

        const recipients = profiles.filter((profile: Profile) =>
            feedback.some((fb: Feedback) => fb.recipientId === profile.id));

        yield put({
            type: STATISTIC_FETCH_SUCCESS,
            data: recipients.map((recipient: Profile) => ({
                profile: recipient,
                feedbacks: feedback
                    .filter((fb: Feedback) => fb.recipientId === recipient.id)
                    .map((fb: Feedback) => ({
                        ...fb,
                        author: profiles.find((author: Profile) => author.id === fb.authorId)
                    }))
            }))
        });
    } catch (e) {
        yield put({type: STATISTIC_FETCH_ERROR, error: e});
    }
}

export function* statisticFetchDataSaga() {
    yield takeEvery(STATISTIC_FETCH_REQUEST, statisticFetch);
}
